export const createImmutableConfig = () => {
  const rawConfig = {
    base: import.meta.env.VITE_API_BASE || '',
    first: import.meta.env.VITE_API_FIRST || '',
    second: import.meta.env.VITE_API_SECOND || ''
  }
  
  const urls = {
    first: `${rawConfig.base}${rawConfig.first}`,
    second: `${rawConfig.base}${rawConfig.second}`
  }
  
  const immutableHandler = {
    get(target, prop) {
      const value = target[prop]
      if (value && typeof value === 'object' && !Object.isFrozen(value)) {
        return new Proxy(value, immutableHandler)
      }
      return value
    },
    set() {
      throw new Error('API配置是只读的，不允许修改')
    },
    deleteProperty() {
      throw new Error('API配置是只读的，不允许删除')
    },
    defineProperty() {
      throw new Error('API配置是只读的，不允许定义新属性')
    }
  }
  
  return new Proxy(urls, immutableHandler)
}

// 导出不可变配置
export const API_URLS = createImmutableConfig()